import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import auth from "../Account/Auth";

function Banner() {
  const location = useLocation();

  const [discountData, setDiscountData] = useState({});
  const [userPlan, setUserPlan] = useState("unknown");
  const [userFullName, setUserFullName] = useState("");

  useEffect(() => {
    const discountDataFromStorage = auth.getProperty({
      storageKey: "userDiscount",
      path: [],
      fallback: {},
    });
    const userPlanFromStorage = auth.getProperty({
      storageKey: "userSession",
      path: ["profileObj", "planStatus", "status"],
      fallback: "unknown",
    });
    const userFullNameFromStorage = auth.getProperty({
      storageKey: "userSession",
      path: ["profileObj", "name"],
      fallback: "",
    });

    setDiscountData(discountDataFromStorage);
    setUserPlan(userPlanFromStorage);
    setUserFullName(userFullNameFromStorage);
  }, [location]); // dependency on location ensures re-check on location change

  const discountPercentage = discountData?.discountAmount;
  const discountName = discountData?.discountName;

  if (userPlan !== "free" || !discountName || !discountPercentage) {
    return null; // Do not render banner if any data is missing/invalid
  }

  return (
    <div
      id="banner"
      tabIndex="-1"
      className="tw-grid tw-z-50 tw-py-3 tw-px-4 tw-w-full tw-bg-white sm:tw-grid-cols-3 dark:tw-bg-gray-800"
    >
      <div className="tw-self-center tw-pr-6 tw-mb-3 sm:tw-col-span-2 sm:tw-mb-0 sm:tw-pr-0">
        <p className="tw-text-gray-900 dark:tw-text-white">
          Hey{" "}
          {userFullName && userFullName.split(" ")[0] && (
            <>{userFullName.split(" ")[0]}</>
          )}
          , Free Plan User? Here you are a <b>{discountPercentage}%</b> discount
          with code: <b>{discountName}</b>
        </p>
      </div>
      <div className="tw-flex tw-justify-center lg:!tw-justify-end">
        <div className="tw-flex tw-items-center sm:tw-space-x-4">
          <a
            href="/upgrade"
            className="tw-flex tw-items-center tw-py-2 tw-px-4 tw-text-sm tw-font-medium tw-text-center tw-text-white tw-rounded-lg tw-bg-primary-700 sm:tw-w-auto hover:tw-bg-primary-800 focus:tw-ring-4 focus:tw-outline-none focus:tw-ring-primary-300 dark:tw-bg-primary-600 dark:hover:tw-bg-primary-700 dark:tw-ring-primary-800"
          >
            Choose Plan -{discountPercentage}%
          </a>
        </div>
      </div>
    </div>
  );
}

export default Banner;
